module.exports = __webpack_public_path__ + "img/pic_bank_ICBC@2x.17027633.png";